import {
  DIGITALK_CONTAINER_ID,
  DIGITALK_SCRIPT_URL,
  OPEN_CHAT_SELECTOR,
} from "./constants";

export const injectChatScript = (frameDocument: Document): void => {
  const script = frameDocument.createElement("script");
  script.src = DIGITALK_SCRIPT_URL;
  script.defer = true;
  frameDocument.getElementById(DIGITALK_CONTAINER_ID)?.appendChild(script);
};

export const isChatOpen = (frameDocument: Document): boolean =>
  Boolean(frameDocument.querySelector(OPEN_CHAT_SELECTOR));
